module.exports = __webpack_public_path__ + "media/images/logo-3de09fe90065c4595ad96e6f017fd527.png";